<fc-general-modal
  [baseId]="baseId"
  [form]="form"
  [fcModalItemContext]="fcModalItemContext"
  (saveForm)="save()"
  (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default full-modal-tabs" [disableRipple]="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Contact Info</span>
          <mat-badge
            *ngIf="getFormValidationErrors(contactInfoGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-insurance-plan-contact-info-tab
          [isDataLoaded]="isDataLoaded"
          [baseId]="baseId"
          [form]="contactInfoGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext">
        </fc-insurance-plan-contact-info-tab>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Settings</span>
          <mat-badge
            *ngIf="getFormValidationErrors(settingsGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-insurance-plan-settings-tab
          [isDataLoaded]="isDataLoaded"
          [baseId]="baseId"
          [form]="settingsGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext">
        </fc-insurance-plan-settings-tab>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Clinical</span>
          <mat-badge
            *ngIf="getFormValidationErrors(clinicalGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-insurance-plan-clinical-tab
          [isDataLoaded]="isDataLoaded"
          [baseId]="baseId"
          [form]="clinicalGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext">
        </fc-insurance-plan-clinical-tab>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>CHC</span>
          <mat-badge
            *ngIf="getFormValidationErrors(chcGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-insurance-plan-chc-tab
          [isDataLoaded]="isDataLoaded"
          [baseId]="baseId"
          [form]="chcGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext">
        </fc-insurance-plan-chc-tab>
      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-modal>